mutation validateRegistrationField($fieldName: String!, $inputFieldValue: String!, $id: String ) {
    validateRegistrationField(fieldName: $fieldName, inputFieldValue: $inputFieldValue, id: $id)
}
